import React, { useRef, useEffect } from 'react';
import './services.css';
import buffet from '../../assets/buffet.jpg';
import jacuzzi from '../../assets/jacuzzi.jpg';
import spa from '../../assets/spa.jpg';
import bdsm from '../../assets/bdsm.png';

const Services = () => {
    // Using useRef to get references to DOM elements
    const nextDom = useRef(null);
    const prevDom = useRef(null);
    const carouselDom = useRef(null);
    const listItemDom = useRef(null);
    const thumbnailDom = useRef(null);

    useEffect(() => {
        // Assigning event handlers in useEffect with empty dependency array to run once after mount
        if (nextDom.current && prevDom.current && carouselDom.current && listItemDom.current && thumbnailDom.current) {
            nextDom.current.onclick = function() {
                showSlider('next');
            };
            prevDom.current.onclick = function() {
                showSlider('prev');
            };
        }
    }, []); // Empty dependency array ensures this effect runs only once after mount

    let timeRunning = 3000;
    let timeAutoNext = 7000;
    let runTimeOut;
    let runAutoRun = setTimeout(() => {
        if (nextDom.current) {
            nextDom.current.click();
        }
    }, timeAutoNext);

    function showSlider(type) {
        const itemSlider = document.querySelectorAll('.carousel .list .item');
        const itemThumbnail = document.querySelectorAll('.carousel .thumbnail .item');

        if (type === 'next') {
            listItemDom.current.appendChild(itemSlider[0]);
            thumbnailDom.current.appendChild(itemThumbnail[0]);
            carouselDom.current.classList.add('next');
            console.log('added next')
        } else {
            const positionLastItem = itemSlider.length - 1;
            listItemDom.current.prepend(itemSlider[positionLastItem]);
            thumbnailDom.current.prepend(itemThumbnail[positionLastItem]);
            carouselDom.current.classList.add('prev');
        }

        clearTimeout(runTimeOut);
        runTimeOut = setTimeout(() => {
            carouselDom.current.classList.remove('next');
            carouselDom.current.classList.remove('prev');
        }, timeRunning);

        clearTimeout(runAutoRun);
        runAutoRun = setTimeout(() => {
            if (nextDom.current) {
                nextDom.current.click();
            }
        }, timeAutoNext);
    }
  return (
    <section className='services' id='services'>
        <div ref={carouselDom} className="carousel">
            <div ref={listItemDom} className="list">
                <div className="item">
                    <img src={buffet}/>
                    <div className="content">
                        <div className="logo">Services</div>
                        <div className="title">Unlimited Drinks and Gourmet Buffet</div>
                        <div className="desc">Savor unlimited drinks from our premium selection and indulge in a gourmet buffet crafted by top chefs. Enjoy a culinary journey that perfectly complements your night of luxury and excitement.</div>
                        <button className="btn">Book Now</button>
                    </div>
                </div>
                <div className="item">

                    <img src={jacuzzi}/>
                    <div className="content">
                        <div className="logo">Services</div>
                        <div className="title">Relaxation in Our Jacuzzi</div>
                        <div className="desc">Unwind in our lavish jacuzzi, designed to provide the utmost relaxation. Let the warm, soothing waters melt away your stress as you immerse yourself in pure bliss.</div>
                        <button className="btn">Book Now</button>
                    </div>
                </div>
                <div className="item">
                    <img src={spa}/>
                    <div className="content">
                        <div className="logo">Services</div>
                        <div className="title">Complimentary Massage and Spa Services</div>
                        <div className="desc">Rejuvenate your body and mind with our complimentary massage and spa services. Our skilled therapists are here to ensure you leave feeling refreshed, revitalized, and completely pampered.</div>
                        <button className="btn">Book Now</button>
                    </div>
                </div>
                <div className="item">
                    <img src={bdsm}/>
                    <div className="content">
                        <div className="logo">Services</div>
                        <div className="title">Access to Underground BDSM Facilities</div>
                        <div className="desc">Unlock the door to a world of sensual exploration with exclusive access to our underground BDSM facilities. Experience a discreet, luxurious environment designed for your ultimate pleasure and comfort.</div>
                        <button className="btn">Book Now</button>
                    </div>
                </div>
            </div>
            <div ref={thumbnailDom} className="thumbnail">
                <div className="item">
                    <img src={jacuzzi} alt="" />
                    <div className="content">
                        <div className="title">
                            Jacuzzi
                        </div>
                        <div className="desc">
                            Relaxation in Our Jacuzzi
                        </div>
                    </div>
                </div>
                <div className="item">
                    <img src={spa} alt="" />
                    <div className="content">
                        <div className="title">
                            Spa
                        </div>
                        <div className="desc">
                            Massage and Spa Services
                        </div>
                    </div>
                </div>
                <div className="item">
                    <img src={bdsm} alt="" />
                    <div className="content">
                        <div className="title">
                            BDSM
                        </div>
                        <div className="desc">
                            Underground BDSM Facilities
                        </div>
                    </div>
                </div>
                <div className="item">
                    <img src={buffet} alt="" />
                    <div className="content">
                        <div className="title">
                            Buffet
                        </div>
                        <div className="desc">
                            Free Drinks and Gourmet Buffet
                        </div>
                    </div>
                </div> 
            </div>
            <div className="arrows">
                <button id='prev' ref={prevDom}>{String.fromCharCode(60)}</button>
                <button id='next' ref={nextDom}>{String.fromCharCode(62)}</button>
            </div>
            <div className="time"></div>
        </div>
    </section>
  )
}

export default Services